import styled, { css } from 'styled-components';
import _Section from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/Section';
import _Text from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/Text';
import _Title from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/Title';
import _Topic from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/Topic';
import theme from 'src/utils/theme';
import BackgroundDesktopEn from './images/background-desktop-en-2x-min.png';
import BackgroundDesktopEs from './images/background-desktop-es-2x-min.png';
import BackgroundDesktopDe from './images/background-desktop-de-2x-min.png';
import BackgroundDesktopFr from './images/background-desktop-fr-2x-min.png';
import BackgroundMobileEn from './images/background-mobile-en-4x-min.png';
import BackgroundMobileEs from './images/background-mobile-es-4x-min.png';
import BackgroundMobileDe from './images/background-mobile-de-4x-min.png';
import BackgroundMobileFr from './images/background-mobile-fr-4x-min.png';
import BackgroundTabletEn from './images/background-tablet-en-2x-min.png';
import BackgroundTabletEs from './images/background-tablet-es-2x-min.png';
import BackgroundTabletDe from './images/background-tablet-de-2x-min.png';
import BackgroundTabletFr from './images/background-tablet-fr-2x-min.png';

export const Card = styled.div(
  ({ theme }) => css`
    width: 100%;
    max-width: 540px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: ${theme.sz.s5};

    @media (min-width: 1152px) {
      margin-right: unset;
      padding-top: 228px;
      padding-bottom: unset;
    }
  `,
);

export const Section = styled(_Section)<{ $sourceLanguageLocale: string }>(
  ({ theme, $sourceLanguageLocale }) => css`
    padding-top: calc(174.0625% + ${theme.sz.s2});
    background-color: ${theme.co.neutral0};
    background-position-x: center;
    background-position-y: top;
    background-repeat: no-repeat;
    background-size: contain;

    ${
      $sourceLanguageLocale === 'en' &&
      css`
        background-image: url(${BackgroundMobileEn});
      `
    }
    ${
      $sourceLanguageLocale === 'es' &&
      css`
        background-image: url(${BackgroundMobileEs});
      `
    }
    ${
      $sourceLanguageLocale === 'de' &&
      css`
        background-image: url(${BackgroundMobileDe});
      `
    }
    ${
      $sourceLanguageLocale === 'fr' &&
      css`
        background-image: url(${BackgroundMobileFr});
      `
    }

    @media (min-width: ${theme.sz.md}) {
      padding-top: 696px;
      background-size: 1152px 696px;

      ${
        $sourceLanguageLocale === 'en' &&
        css`
          background-image: url(${BackgroundTabletEn});
        `
      }
      ${
        $sourceLanguageLocale === 'es' &&
        css`
          background-image: url(${BackgroundTabletEs});
        `
      }
      ${
        $sourceLanguageLocale === 'de' &&
        css`
          background-image: url(${BackgroundTabletDe});
        `
      }
      ${
        $sourceLanguageLocale === 'fr' &&
        css`
          background-image: url(${BackgroundTabletFr});
        `
      }
    }

    @media (min-width: 1152px) {
      height: 870px;
      padding-top: unset;
      background-size: 1440px 870px;

      ${
        $sourceLanguageLocale === 'en' &&
        css`
          background-image: url(${BackgroundDesktopEn});
        `
      }
      ${
        $sourceLanguageLocale === 'es' &&
        css`
          background-image: url(${BackgroundDesktopEs});
        `
      }
      ${
        $sourceLanguageLocale === 'de' &&
        css`
          background-image: url(${BackgroundDesktopDe});
        `
      }
      ${
        $sourceLanguageLocale === 'fr' &&
        css`
          background-image: url(${BackgroundDesktopFr});
        `
      }
    }
  `,
);

export const SectionContent = _Section.Content;

export const Text = styled(_Text).attrs({
  $desktopStyles: css`
    margin-bottom: ${theme.sz.s8};
    line-height: 150%;
    /* or 30px */
  `,
  $mobileStyles: css`
    margin-bottom: ${theme.sz.s4};
  `,
})(() => css``);

export const Title = styled(_Title).attrs({
  $desktopStyles: css`
    margin-bottom: ${theme.sz.s8};
    font-size: 56px;
    line-height: 125%;
    /* or 70px */
  `,
  $mobileStyles: css`
    margin-bottom: ${theme.sz.s4};
  `,
})(() => css``);

export const Topic = styled(_Topic).attrs({
  $desktopStyles: css`
    margin-bottom: ${theme.sz.s4};
  `,
  $mobileStyles: css`
    margin-bottom: ${theme.sz.s4};
  `,
})(() => css``);
